import { palette } from '@/theme/palette';
import type { PageId } from '@/store/useNavigationStore';

/**
 * Single source of truth for the five top-level pages: where each
 * highway points, its accent colour, and the destination screen copy.
 */
export interface PageMeta {
  id: PageId;
  label: string;
  /** Yaw (radians) around +Y, measured clockwise from "forward" (-Z). */
  yaw: number;
  color: string;
  body: string;
}

const TAU = Math.PI * 2;

export const PAGES: readonly PageMeta[] = [
  {
    id: 'hizmetler',
    label: 'Hizmetler',
    yaw: 0,
    color: palette.blue,
    body:
      'Yönetilen IT, AI destekli veri zekâsı, siber güvenlik ve bulut altyapı.\n' +
      'SLA bazlı destekle uçtan uca kurumsal teknoloji çözümleri.',
  },
  {
    id: 'hakkimizda',
    label: 'Hakkımızda',
    yaw: TAU / 5, // 72° to the right of forward — matches the user's "sağ taraf"
    color: palette.purple,
    body:
      '2018’den bu yana 200+ kurumsal müşteriye hizmet veren bir IT ekibi.\n' +
      'İstanbul merkezli, ulusal sahada uçtan uca sorumluluk alan bir takım.',
  },
  {
    id: 'iletisim',
    label: 'İletişim',
    yaw: (2 * TAU) / 5,
    color: palette.green,
    body:
      'info@pinorion.com\n' +
      '+90 (212) 000 00 00\n' +
      'Maslak, İstanbul',
  },
  {
    id: 'sektorel',
    label: 'Sektörel\nÇözümler',
    yaw: (3 * TAU) / 5,
    color: palette.orange,
    body:
      'Finans, sağlık, üretim ve perakende sektörlerine özel mimariler.\n' +
      'Uyum, performans ve maliyet üçgeninde dikey çözümler.',
  },
  {
    id: 'blog',
    label: 'Blog',
    yaw: (4 * TAU) / 5,
    color: palette.pink,
    body:
      'En son güvenlik, AI ve bulut başlıklarında uygulamalı içgörüler.\n' +
      'Mühendis ekibimizden saha hikâyeleri ve incelemeler.',
  },
];

export function getPage(id: PageId | null): PageMeta | null {
  if (!id) return null;
  return PAGES.find((p) => p.id === id) ?? null;
}
